import { render, staticRenderFns } from "./faceDetection.vue?vue&type=template&id=25fe4fe8&scoped=true"
import script from "./faceDetection.vue?vue&type=script&lang=js"
export * from "./faceDetection.vue?vue&type=script&lang=js"
import style0 from "./faceDetection.vue?vue&type=style&index=0&id=25fe4fe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fe4fe8",
  null
  
)

export default component.exports